import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["firstName", "lastName", "legalName"]

  connect() {
    this.updateLegalName()
    this.firstNameTarget.addEventListener("input", this.updateLegalName.bind(this))
    this.lastNameTarget.addEventListener("input", this.updateLegalName.bind(this))
  }

  disconnect() {
    if (this.hasFirstNameTarget) {
      this.firstNameTarget.removeEventListener("input", this.updateLegalName.bind(this))
    }
    if (this.hasLastNameTarget) {
      this.lastNameTarget.removeEventListener("input", this.updateLegalName.bind(this))
    }
  }

  updateLegalName() {
    if (!this.hasFirstNameTarget || !this.hasLastNameTarget || !this.hasLegalNameTarget) return

    const firstName = this.firstNameTarget.value.trim()
    const lastName = this.lastNameTarget.value.trim()
    const legalName = [firstName, lastName].filter(Boolean).join(" ")
    this.legalNameTarget.value = legalName
  }
}

